import { Injectable } from "@angular/core";
import { createClient } from "@supabase/supabase-js";
import { environment } from "src/environments/environment";
import { AuthStorage } from "src/app/core/storage/auth-storage.class";

@Injectable({
  providedIn: "root",
})
export class SupabaseClientService {
  readonly supabaseClient = createClient(
    environment.supabaseClientConfig.supabaseUrl,
    environment.supabaseClientConfig.supabaseKey,
    {
      auth: {
        storage: new AuthStorage(),
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: false,
      },
    }
  );
}
